import { getTextStyles } from 'app/components/presentation/text/styles';
import ActionArrow, { Direction } from 'app/components/svgs/ActionArrow';
import { GREY_S } from 'app/constants/Colors';
import { Category, Course } from 'app/constants/schemas';
import Translation, { Fallback } from 'app/containers/lesson/text/Translation';
import CategoryLink from 'app/containers/materials/CategoryLink';
import { EntityStringId } from 'app/types/entity';
import { useClasses } from 'app/utils/css';
import React, { createContext } from 'react';

interface IBreadcrumbsContextProps {
  categoryId: EntityStringId;
  courseId: EntityStringId;
}

const BreadcrumbsContext = createContext<IBreadcrumbsContextProps | null>(null);

export const BreadcrumbsProvider = BreadcrumbsContext.Provider;

const Breadcrumbs = () => {
  const classes = useClasses({
    container: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
    },

    containerText: getTextStyles({
      color: GREY_S,
      fontSize: '14px',
      letterSpacing: '0.8px',
    }),

    delimiter: {
      margin: '0 5px',
    },

    link: {
      color: 'inherit',
      textDecoration: 'none',
    },
  });

  return (
    <BreadcrumbsContext.Consumer>{(breadcrumbsContextProps) => {
      if (breadcrumbsContextProps === null) {
        return null;
      }

      const { categoryId, courseId } = breadcrumbsContextProps;

      return (
        <div className={classes.containerText}>
          <div className={classes.container}>
            <CategoryLink categoryId={categoryId} className={classes.link}>
              <Translation id={categoryId} fallback={Fallback.TargetLanguage} field="nameText" type={Category} />
            </CategoryLink>

            <span className={classes.delimiter} />

            <ActionArrow color="currentColor" size="0.6em" direction={Direction.Right} />

            <span className={classes.delimiter} />

            <CategoryLink categoryId={categoryId} courseId={courseId} className={classes.link}>
              <Translation id={courseId} fallback={Fallback.TargetLanguage} field="nameText" type={Course} />
            </CategoryLink>
          </div>
        </div>
      );
    }}</BreadcrumbsContext.Consumer>
  );
};

export default Breadcrumbs;
